import styled from 'styled-components';
import IconChevronDownOutline from './IconChevronDownOutline';
var IconChevronUpOutline = /*#__PURE__*/styled(IconChevronDownOutline).withConfig({
  displayName: "IconChevronUpOutline",
  componentId: "c11n-8-111-1__sc-1d3o5nk-0"
})(["transform:rotate(180deg);"]);
export default IconChevronUpOutline;